import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, newKey } from "../lib/api";

const RegistrationContext = createContext(null);
export const useRegistration = () => useContext(RegistrationContext);

const emptyServices = () => ({
  football: { type: "none", days: {} },
  goalkeeper: { type: "none", days: {} },
  feedback: { type: "none", days: {} },
  development_package: false,
  meals: { days: [] },
});

export const emptyParticipant = () => ({
  _k: newKey(),
  first_name: "", last_name: "", dob: "", gender: "",
  tshirt_size: "", shorts_size: "", socks_size: "",
  medical_none: true, medical_details: "",
  meal_dietary: "",
  services: emptyServices(),
});

const emptyGuardian = () => ({
  first_name: "", last_name: "", email: "", phone: "", country: "", marketing_consent: false, referral_code: "", referral_partner: "",
});

export function RegistrationProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [participants, setParticipants] = useState([emptyParticipant()]);
  const [guardian, setGuardian] = useState(emptyGuardian());
  const [consents, setConsents] = useState({
    guardian_confirm: false, terms: false, privacy: false, medical_share: false,
  });
  const [giftRecipientIndex, setGiftRecipientIndex] = useState(0);
  const [quote, setQuote] = useState(null);

  const loadConfig = useCallback(async () => {
    const { data } = await api.get("/config/public");
    setConfig(data);
  }, []);

  useEffect(() => { loadConfig(); }, [loadConfig]);

  const refreshQuote = useCallback(async (parts) => {
    try {
      const { data } = await api.post("/quote", { participants: parts });
      setQuote(data);
      return data;
    } catch (e) {
      setQuote(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const t = setTimeout(() => { refreshQuote(participants); }, 250);
    return () => clearTimeout(t);
  }, [participants, refreshQuote]);

  const value = {
    config, loadConfig,
    participants, setParticipants,
    guardian, setGuardian,
    consents, setConsents,
    giftRecipientIndex, setGiftRecipientIndex,
    quote, refreshQuote,
  };
  return <RegistrationContext.Provider value={value}>{children}</RegistrationContext.Provider>;
}
